/**
 * The web app routes thread-list reads through TanStack Query so several
 * mounts share one request. The pane has one chat and no query client, so
 * the copied adapter always takes its direct `client.threads.search` path;
 * these exports exist only so that file stays byte-for-byte diffable.
 */
import type { QueryClient } from "@tanstack/react-query";

import type {
  AgentThreadMetadata,
  AgentThreadSummary
} from "@/agents-v2/chat-runtime/types";

export type AgentThreadsScope = {
  assistantId: string;
  scopeMetadata?: AgentThreadMetadata;
};

export const AGENT_THREADS_PAGE_SIZE = 100;

/**
 * Not used by the pane: it never passes a query client to the adapter.
 * @returns Never resolves with data; throws to make an accidental call loud.
 */
export const fetchAgentThreads = (
  _queryClient: QueryClient,
  _client: unknown,
  _page: AgentThreadsScope & { limit?: number; offset?: number }
): Promise<AgentThreadSummary[]> =>
  Promise.reject(new Error("fetchAgentThreads is not wired in the Word pane"));

/**
 * Not used by the pane (see `fetchAgentThreads`).
 * @returns A resolved promise.
 */
export const invalidateAgentThreads = async (
  _queryClient: QueryClient,
  _scope: AgentThreadsScope
): Promise<void> => undefined;
